

export module AppConstants {
    export const routes = {
        HOME: '',
        CONTACT: 'contact',
        SYSTEM_FACTURACION: 'system/facturacion-electronica',
        SYSTEM_ENCUENTRAME: 'system/encuentrame',
        SYSTEM_VENTASONLINE: 'system/ventas-online',
        SABERMAS: 'saberMas',
        SERVICIOS: 'servicios',
    }

    export const PlanesCentrix = {
        Servicios: [
            {
                id: 'facturacion',
                titulo: 'Facturación Electrónica',
                subtitulo: 'Cumplimiento y Agilidad',
                descripcion: 'La solución integral para el cumplimiento tributario y gestión comercial.',
                puntosClave: ['Sincronización con SUNAT', 'Control de Inventarios', 'Reportes Inteligentes'],
                icono: 'assets/imagenes/sincronizacion_con_sunat.png',
                color: '#1a5f79',
                url: AppConstants.routes.SYSTEM_FACTURACION,
                imageLeft: true
            },
            {
                id: 'qr',
                titulo: 'Sistema Encuéntrame QR',
                subtitulo: 'Seguridad Inteligente',
                descripcion: 'Protege lo que más amas mediante códigos QR de identificación.',
                puntosClave: ['Registrate con nosotros e ingresa la información de emergencia', 'Genera y descarga tu QR', 'Escaneo y Comunicación'],
                icono: 'assets/imagenes/encuentrame_2.png',
                color: '#1a5f79',
                url: AppConstants.routes.SYSTEM_ENCUENTRAME,
                imageLeft: false
            },
            {
                id: 'ecommerce',
                titulo: 'E-commerce & Ventas Online',
                subtitulo: 'Escalabilidad Digital',
                descripcion: 'Tu tienda virtual completa con gestión de inventario sincronizada y pasarelas de pago locales.',
                puntosClave: ['Catálogo Autogestionable', 'Carrito de Compras y Checkout', 'Pasarelas de Pago Integradas','Panel Administrativo Interno'],
                icono: 'assets/imagenes/online_3.png',
                color: '#1a5f79',
                url: AppConstants.routes.SYSTEM_VENTASONLINE,
                imageLeft: true
            }
        ],
        General: {
            tituloPlanes: 'Planes diseñados para tu crecimiento',
        },
        Facturacion: [
            {
                id: 0,
                label: 'Paga mensualmente',
                isDscto: 0,
                items: [
                    {
                        title: 'EMPRENDEDOR',
                        price: 89,
                        isOferta: false,
                        priceOferta: 0,
                        detailOferta: '',
                        isPopular: false,
                        detail: [
                            { description: 'Hasta 150 Facturas y Boletas Electrónicas.' },
                            { description: 'Ingresos ilimitados al mes.' },
                            { description: '2 usuarios con acceso. Uno para ti y Otro para tu Contador.' },
                            { description: 'Soporte 24/7 gratis.' },
                        ]
                    },
                    {
                        title: 'PYME',
                        price: 129,
                        isOferta: false,
                        priceOferta: 0,
                        detailOferta: '',
                        isPopular: false,
                        detail: [
                            { description: 'Incluye SIRE.' },
                            { description: 'Hasta 300 Facturas y Boletas Electrónicas.' },
                            { description: 'Ingresos ilimitados al mes.' },
                            { description: '2 usuarios con acceso. + Uno para tu Contador.' },
                            { description: 'Soporte 24/7 gratis.' },
                        ]
                    },
                    {
                        title: 'PRO',
                        price: 189,
                        isOferta: false,
                        priceOferta: 0,
                        detailOferta: '',
                        isPopular: true,
                        detail: [
                            { description: 'Incluye SIRE.' },
                            { description: 'Hasta 700 Facturas y Boletas Electrónicas.' },
                            { description: 'Ingresos ilimitados al mes.' },
                            { description: '3 usuarios con acceso. + Uno para tu Contador.' },
                            { description: 'Soporte 24/7 gratis.' },
                        ]
                    },
                    {
                        title: 'PLUS',
                        price: 299,
                        isOferta: false,
                        priceOferta: 0,
                        detailOferta: '',
                        isPopular: false,
                        detail: [
                            { description: 'Incluye SIRE.' },
                            { description: 'Hasta 1500 Facturas y Boletas Electrónicas.' },
                            { description: 'Ingresos ilimitados al mes.' },
                            { description: '8 usuarios con acceso. + Uno para tu Contador.' },
                            { description: 'Soporte 24/7 gratis.' },
                        ]
                    }
                ],
            },
            {
                id: 1,
                label: 'Paga anualmente',
                isDscto: 10,
                items: [
                    {
                        title: 'EMPRENDEDOR',
                        price: 1068,
                        isOferta: true,
                        priceOferta: 961.2,
                        detailOferta: 'Con el pago anual',
                        isPopular: false,
                        detail: [
                            { description: 'Hasta 150 Facturas y Boletas Electrónicas.' },
                            { description: 'Ingresos ilimitados al mes.' },
                            { description: '2 usuarios con acceso. Uno para ti y Otro para tu Contador.' },
                            { description: 'Soporte 24/7 gratis.' },
                        ]
                    },
                    {
                        title: 'PYME',
                        price: 1548,
                        isOferta: true,
                        priceOferta: 1393.2,
                        detailOferta: 'Con el pago anual',
                        isPopular: false,
                        detail: [
                            { description: 'Incluye SIRE.' },
                            { description: 'Hasta 300 Facturas y Boletas Electrónicas.' },
                            { description: 'Ingresos ilimitados al mes.' },
                            { description: '2 usuarios con acceso. + Uno para tu Contador.' },
                            { description: 'Soporte 24/7 gratis.' },
                        ]
                    },
                    {
                        title: 'PRO',
                        price: 2268,
                        isOferta: true,
                        priceOferta: 2041.2,
                        detailOferta: 'Con el pago anual',
                        isPopular: true,
                        detail: [
                            { description: 'Incluye SIRE.' },
                            { description: 'Hasta 700 Facturas y Boletas Electrónicas.' },
                            { description: 'Ingresos ilimitados al mes.' },
                            { description: '3 usuarios con acceso. + Uno para tu Contador.' },
                            { description: 'Soporte 24/7 gratis.' },
                        ]
                    },
                    {
                        title: 'PLUS',
                        price: 3588,
                        isOferta: true,
                        priceOferta: 3229.2,
                        detailOferta: 'Con el pago anual',
                        isPopular: false,
                        detail: [
                            { description: 'Incluye SIRE.' },
                            { description: 'Hasta 1500 Facturas y Boletas Electrónicas.' },
                            { description: 'Ingresos ilimitados al mes.' },
                            { description: '8 usuarios con acceso. + Uno para tu Contador.' },
                            { description: 'Soporte 24/7 gratis.' },
                        ]
                    }
                ],
            },
        ],
        Facturacion_Caracteristicas: [
            {
                titulo: 'Sincronización con SUNAT',
                descripcion: 'Envío automático de boletas, facturas y notas de crédito en tiempo real.',
                imagen: 'assets/imagenes/sincronizacion_con_sunat.png'
            },
            {
                titulo: 'Control de Inventarios',
                descripcion: 'Gestión de stock automática por cada venta realizada en tus sucursales.',
                imagen: 'assets/imagenes/control_inventarios.png'
            },
            {
                titulo: 'Reportes Inteligentes',
                descripcion: 'Visualiza tus ganancias y productos más vendidos con gráficos dinámicos.',
                imagen: 'assets/imagenes/reporte_inteligente.png'
            }
        ],
        Facturacion_Detalles: {
            titulo: 'Sistema de Ventas y ',
            tituloBold: 'Facturación',
            subtitulo: 'La solución integral para el cumplimiento tributario y gestión comercial.',

        },
        Encuentrame: [
            {
                id: 0,
                label: 'Paga mensualmente',
                isDscto: 0,
                items: [
                    {
                        title: 'EMPRENDEDOR',
                        price: 89,
                        isOferta: false,
                        priceOferta: 0,
                        detailOferta: '',
                        isPopular: false,
                        detail: [
                            { description: 'Hasta 150 Facturas y Boletas Electrónicas.' },
                            { description: 'Ingresos ilimitados al mes.' },
                            { description: '2 usuarios con acceso. Uno para ti y Otro para tu Contador.' },
                            { description: 'Soporte 24/7 gratis.' },
                        ]
                    },
                    {
                        title: 'PYME',
                        price: 129,
                        isOferta: false,
                        priceOferta: 0,
                        detailOferta: '',
                        isPopular: false,
                        detail: [
                            { description: 'Incluye SIRE.' },
                            { description: 'Hasta 300 Facturas y Boletas Electrónicas.' },
                            { description: 'Ingresos ilimitados al mes.' },
                            { description: '2 usuarios con acceso. + Uno para tu Contador.' },
                            { description: 'Soporte 24/7 gratis.' },
                        ]
                    },
                    {
                        title: 'PRO',
                        price: 189,
                        isOferta: false,
                        priceOferta: 0,
                        detailOferta: '',
                        isPopular: true,
                        detail: [
                            { description: 'Incluye SIRE.' },
                            { description: 'Hasta 700 Facturas y Boletas Electrónicas.' },
                            { description: 'Ingresos ilimitados al mes.' },
                            { description: '3 usuarios con acceso. + Uno para tu Contador.' },
                            { description: 'Soporte 24/7 gratis.' },
                        ]
                    },
                    {
                        title: 'PLUS',
                        price: 299,
                        isOferta: false,
                        priceOferta: 0,
                        detailOferta: '',
                        isPopular: false,
                        detail: [
                            { description: 'Incluye SIRE.' },
                            { description: 'Hasta 1500 Facturas y Boletas Electrónicas.' },
                            { description: 'Ingresos ilimitados al mes.' },
                            { description: '8 usuarios con acceso. + Uno para tu Contador.' },
                            { description: 'Soporte 24/7 gratis.' },
                        ]
                    }
                ],
            },
            {
                id: 1,
                label: 'Paga anualmente',
                isDscto: 10,
                items: [
                    {
                        title: 'EMPRENDEDOR',
                        price: 1068,
                        isOferta: true,
                        priceOferta: 961.2,
                        detailOferta: 'Con el pago anual',
                        isPopular: false,
                        detail: [
                            { description: 'Hasta 150 Facturas y Boletas Electrónicas.' },
                            { description: 'Ingresos ilimitados al mes.' },
                            { description: '2 usuarios con acceso. Uno para ti y Otro para tu Contador.' },
                            { description: 'Soporte 24/7 gratis.' },
                        ]
                    },
                    {
                        title: 'PYME',
                        price: 1548,
                        isOferta: true,
                        priceOferta: 1393.2,
                        detailOferta: 'Con el pago anual',
                        isPopular: false,
                        detail: [
                            { description: 'Incluye SIRE.' },
                            { description: 'Hasta 300 Facturas y Boletas Electrónicas.' },
                            { description: 'Ingresos ilimitados al mes.' },
                            { description: '2 usuarios con acceso. + Uno para tu Contador.' },
                            { description: 'Soporte 24/7 gratis.' },
                        ]
                    },
                    {
                        title: 'PRO',
                        price: 2268,
                        isOferta: true,
                        priceOferta: 2041.2,
                        detailOferta: 'Con el pago anual',
                        isPopular: true,
                        detail: [
                            { description: 'Incluye SIRE.' },
                            { description: 'Hasta 700 Facturas y Boletas Electrónicas.' },
                            { description: 'Ingresos ilimitados al mes.' },
                            { description: '3 usuarios con acceso. + Uno para tu Contador.' },
                            { description: 'Soporte 24/7 gratis.' },
                        ]
                    },
                    {
                        title: 'PLUS',
                        price: 3588,
                        isOferta: true,
                        priceOferta: 3229.2,
                        detailOferta: 'Con el pago anual',
                        isPopular: false,
                        detail: [
                            { description: 'Incluye SIRE.' },
                            { description: 'Hasta 1500 Facturas y Boletas Electrónicas.' },
                            { description: 'Ingresos ilimitados al mes.' },
                            { description: '8 usuarios con acceso. + Uno para tu Contador.' },
                            { description: 'Soporte 24/7 gratis.' },
                        ]
                    }
                ],
            },
        ],
        Encuentrame_Caracteristicas: [
            {
                titulo: 'Registrate con nosotros e ingresa la información de emergencia',
                descripcion: 'Crea un perfil digital para tu mascota, familiar u objeto. Puedes incluir foto, números de teléfono, dirección, alergias o condiciones médicas importantes.',
                imagen: 'assets/imagenes/encuentrame_1.png'
            },
            {
                titulo: 'Genera y descarga tu QR',
                descripcion: 'Una ves descargues tu QR, colócala en el collar de tu mascota o en la mochila de tu hijo.',
                imagen: 'assets/imagenes/encuentrame_2.png'
            },
            {
                titulo: 'Escaneo y Comunicación',
                descripcion: 'Si alguien encuentra a tu ser querido, escanea el código y verá tu información de contacto. Podrá contactarte através de la información ingresada.',
                imagen: 'assets/imagenes/encuentrame_3.png'
            }
        ],
        Encuentrame_Detalles: {
            titulo: 'Web Encuentrame ',
            tituloBold: 'QR',
            subtitulo: 'Protege lo que más amas.',
        },
        VentasOnline: [
            {
                id: 0,
                label: 'Paga mensualmente',
                isDscto: 0,
                items: [
                    {
                        title: 'EMPRENDEDOR',
                        price: 89,
                        isOferta: false,
                        priceOferta: 0,
                        detailOferta: '',
                        isPopular: false,
                        detail: [
                            { description: 'Hasta 150 Facturas y Boletas Electrónicas.' },
                            { description: 'Ingresos ilimitados al mes.' },
                            { description: '2 usuarios con acceso. Uno para ti y Otro para tu Contador.' },
                            { description: 'Soporte 24/7 gratis.' },
                        ]
                    },
                    {
                        title: 'PYME',
                        price: 129,
                        isOferta: false,
                        priceOferta: 0,
                        detailOferta: '',
                        isPopular: false,
                        detail: [
                            { description: 'Incluye SIRE.' },
                            { description: 'Hasta 300 Facturas y Boletas Electrónicas.' },
                            { description: 'Ingresos ilimitados al mes.' },
                            { description: '2 usuarios con acceso. + Uno para tu Contador.' },
                            { description: 'Soporte 24/7 gratis.' },
                        ]
                    },
                    {
                        title: 'PRO',
                        price: 189,
                        isOferta: false,
                        priceOferta: 0,
                        detailOferta: '',
                        isPopular: true,
                        detail: [
                            { description: 'Incluye SIRE.' },
                            { description: 'Hasta 700 Facturas y Boletas Electrónicas.' },
                            { description: 'Ingresos ilimitados al mes.' },
                            { description: '3 usuarios con acceso. + Uno para tu Contador.' },
                            { description: 'Soporte 24/7 gratis.' },
                        ]
                    },
                    {
                        title: 'PLUS',
                        price: 299,
                        isOferta: false,
                        priceOferta: 0,
                        detailOferta: '',
                        isPopular: false,
                        detail: [
                            { description: 'Incluye SIRE.' },
                            { description: 'Hasta 1500 Facturas y Boletas Electrónicas.' },
                            { description: 'Ingresos ilimitados al mes.' },
                            { description: '8 usuarios con acceso. + Uno para tu Contador.' },
                            { description: 'Soporte 24/7 gratis.' },
                        ]
                    }
                ],
            },
            {
                id: 1,
                label: 'Paga anualmente',
                isDscto: 10,
                items: [
                    {
                        title: 'EMPRENDEDOR',
                        price: 1068,
                        isOferta: true,
                        priceOferta: 961.2,
                        detailOferta: 'Con el pago anual',
                        isPopular: false,
                        detail: [
                            { description: 'Hasta 150 Facturas y Boletas Electrónicas.' },
                            { description: 'Ingresos ilimitados al mes.' },
                            { description: '2 usuarios con acceso. Uno para ti y Otro para tu Contador.' },
                            { description: 'Soporte 24/7 gratis.' },
                        ]
                    },
                    {
                        title: 'PYME',
                        price: 1548,
                        isOferta: true,
                        priceOferta: 1393.2,
                        detailOferta: 'Con el pago anual',
                        isPopular: false,
                        detail: [
                            { description: 'Incluye SIRE.' },
                            { description: 'Hasta 300 Facturas y Boletas Electrónicas.' },
                            { description: 'Ingresos ilimitados al mes.' },
                            { description: '2 usuarios con acceso. + Uno para tu Contador.' },
                            { description: 'Soporte 24/7 gratis.' },
                        ]
                    },
                    {
                        title: 'PRO',
                        price: 2268,
                        isOferta: true,
                        priceOferta: 2041.2,
                        detailOferta: 'Con el pago anual',
                        isPopular: true,
                        detail: [
                            { description: 'Incluye SIRE.' },
                            { description: 'Hasta 700 Facturas y Boletas Electrónicas.' },
                            { description: 'Ingresos ilimitados al mes.' },
                            { description: '3 usuarios con acceso. + Uno para tu Contador.' },
                            { description: 'Soporte 24/7 gratis.' },
                        ]
                    },
                    {
                        title: 'PLUS',
                        price: 3588,
                        isOferta: true,
                        priceOferta: 3229.2,
                        detailOferta: 'Con el pago anual',
                        isPopular: false,
                        detail: [
                            { description: 'Incluye SIRE.' },
                            { description: 'Hasta 1500 Facturas y Boletas Electrónicas.' },
                            { description: 'Ingresos ilimitados al mes.' },
                            { description: '8 usuarios con acceso. + Uno para tu Contador.' },
                            { description: 'Soporte 24/7 gratis.' },
                        ]
                    }
                ],
            },
        ],
        VentasOnline_Caracteristicas: [
            {
                titulo: 'Catálogo Autogestionable',
                descripcion: 'Sube productos, gestiona categorías, precios y ofertas en tiempo real sin depender de programadores.',
                imagen: 'assets/imagenes/online_1.png'
            },
            {
                titulo: 'Carrito de Compras y Checkout',
                descripcion: 'Proceso de compra fluido optimizado para móviles, reduciendo el abandono de carritos.',
                imagen: 'assets/imagenes/online_2.png'
            },
            {
                titulo: 'Pasarelas de Pago Integradas',
                descripcion: 'Acepta tarjetas de crédito, débito, transferencias y billeteras digitales (Yape/Plin) de forma segura.',
                imagen: 'assets/imagenes/online_3.png'
            },
            {
                titulo: 'Panel Administrativo Interno',
                descripcion: 'Gestiona pedidos, clientes y estados de envío desde un solo lugar con métricas de rendimiento.',
                imagen: 'assets/imagenes/reporte_inteligente.png'
            }
        ],
        VentaOnline_Detalles: {
            titulo: 'Sistema de Ventas ',
            tituloBold: 'Online',
            subtitulo: 'Tu página web para ventas online y administración para tus ventas de productos y servicios.',
        }
    };

    export const Contacto = {
        email: 'ventas@centrixperu.com'
    }
    
    export const timeCarrousel = {
        timeSystem: 5000
    }


}